/**
 * practitioner-client-view — Barrel export
 *
 * Phase 1 components (no Sendbird). Phase 2 adds Sendbird wiring to CommentThread.
 */

export { ClientViewHeader } from './ClientViewHeader';
export { ClientStatsStrip } from './ClientStatsStrip';
export { TierBadge } from './TierBadge';
export { SessionPrepCard } from './SessionPrepCard';
export { PrepNoteRow } from './PrepNoteRow';
export { PatternTrendsCard } from './PatternTrendsCard';
export { PatternBar } from './PatternBar';
export { PrivacyNotice } from './PrivacyNotice';
export { AnalysisHistoryCard } from './AnalysisHistoryCard';
export { DeltaBadge } from './DeltaBadge';
export { ConsentGate } from './ConsentGate';
export { CommentThread } from './CommentThread';
export { ChatBubble } from './ChatBubble';
export { ChatInput } from './ChatInput';
